import { render } from "./DeleteInspection.vue?vue&type=template&id=0b738366"
import script from "./DeleteInspection.vue?vue&type=script&lang=js"
export * from "./DeleteInspection.vue?vue&type=script&lang=js"

import "./DeleteInspection.vue?vue&type=style&index=0&id=0b738366&lang=css"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
